import { PartnerActions } from "../actions";

const initialState = {
  partners: [],
  partner: null,
};

export default function partner(state = initialState, action) {
  switch (action.type) {
    case PartnerActions.ACTION_SAVE_PARTNERS:
      return {
        ...state,
        partners: action.payload,
      };
    case PartnerActions.ACTION_SAVE_PARTNER:
      return {
        ...state,
        partner: action.payload,
      };
    default:
      return state;
  }
}

export function getPartners(state) {
  return state.partner.partners;
}
export function getPartner(state) {
  return state.partner.partner;
}
